import React from 'react';

import PropTypes from 'prop-types';

import UserCard from 'components/new_ui/Cards/UserCard';

function dateFormat(value) {
  const date = new Date(value);
  const options = {
    year: 'numeric',
    month: 'long',
  };

  return date.toLocaleDateString('en-US', options);
}

export default function Card({ member }) {
  return (

    <UserCard
      avatar={member.avatar_url}
      name={member.full_name}
      position={`${member.company_position || 'Employee'} at ${member.company}`}
      startWorkDate={(
        <div className="work-date">
          Member since
          <span className="ms-1">{dateFormat(member.created_at)}</span>
        </div>
            )}
      className="member"
    />

  );
}

Card.propTypes = {
  member: PropTypes.object.isRequired,
};
